import DialogDrag from 'vue-dialog-drag';
import { Chrome } from 'vue-color';
import tinycolor from 'tinycolor2';
import * as StaticDesign from '@/components/initializer/static-design.js';

export default {
  props: [
    'defaultColors',
    'clientColors',
    'compiledColors',
    'client',
    'config',
  ],
  components: {
    'dialog-drag': DialogDrag,
    'chrome-picker': Chrome,
  },
  data() {
    return {
      hideColorPicker: true,
      activeKey: false,
      defaultColor: '#ffffff',
      compiledTypes: ['', '-text', '-hover', '-text-hover'],
      staticDesign: StaticDesign.getAllDesigns(),
    };
  },
  computed: {
    allColorKeys() {
      const all = Object.assign({}, this.defaultColors, this.clientColors, this.compiledColors);
      return Object
        .keys(all).filter(k => !k.endsWith('-hover') && !k.endsWith('-text') && !k.endsWith('-text-hover'))
        .sort();
    },
    defaultClientColors() {
      return this.clientsDefaultColors[this.client].colors;
    },
    clientsDefaultColors() {
      if (Object.prototype.hasOwnProperty.call(this.config, 'colors')
          && Object.prototype.hasOwnProperty.call(this.config, 'logo')) {
        return Object.assign({ }, this.staticDesign, { default: this.config });
      }
      return this.staticDesign;
    },
  },
  methods: {
    changeColor(key, color, e) {
      this.$refs.colorPicker.$el.style.left = `${e.layerX}px`;
      this.$refs.colorPicker.$el.style.top = `${e.layerY}px`;
      this.activeKey = key;
      this.defaultColor = color;
      if (this.hideColorPicker) {
        document.addEventListener('click', this.hide);
        this.hideColorPicker = false;
      }
    },
    hide(e) {
      let found = false;
      e.path.forEach(path => {
        if (path.className === 'c-chrome' || path.className === 'color-block') {
          found = true;
        }
      });
      if (!found) {
        this.hideColorPicker = true;
        document.removeEventListener('click', this.hide);
      }
    },
    updateColors(color) {
      if (this.activeKey) {
        this.$set(this.clientColors, this.activeKey, color.hex);
        this.$emit('update:clientColors', this.clientColors);
      }
    },
    checkOverwrite(key) {
      return Object.prototype.hasOwnProperty.call(this.clientColors, key);
    },
    getCompiledColor(key) {
      return Object.prototype.hasOwnProperty
              .call(this.compiledColors, key) ? this.compiledColors[key] : '';
    },
    getSpinColor(color) {
      return tinycolor.mostReadable(color, ['#000', '#fff']).toHexString();
    },
    getKeyStyle(key) {
      const c = this.getCompiledColor(key);
      return {
        backgroundColor: c,
        color: this.getSpinColor(c),
      };
    },
    checkDefaultColor(key) {
      return Object.prototype.hasOwnProperty
              .call(this.defaultClientColors, key) ? this.defaultClientColors[key] : false;
    },
    updateClientColor(key, useDefaultColor = false) {
      const color = this.checkDefaultColor(key);
      if (color && !useDefaultColor) this.$set(this.clientColors, key, color);
      else this.$delete(this.clientColors, key);
    },
    resetKeyColor(key, useDefaultColor = false) {
      if (key === 'all') {
        Object.keys(this.compiledColors).forEach(objKey => {
          this.updateClientColor(objKey);
        });
      } else if (useDefaultColor) {
        this.updateClientColor(key, useDefaultColor);
      } else {
        this.compiledTypes.forEach(value => {
          this.updateClientColor(`${key}${value}`);
        });
      }
      this.$emit('update:clientColors', this.clientColors);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/initializer/color-picker/ColorPicker.js